"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@requestnetwork/utils");
/**
 * Compute the payment reference
 *
 * @param requestId The requestId
 * @param salt The salt for the request
 * @param address Payment or refund address
 */
function calculate(requestId, salt, address) {
    if (!requestId || !salt || !address) {
        throw new Error('RequestId, salt and address are mandatory to calculate the payment reference');
    }
    // "The value is the last 8 bytes of a salted hash of the requestId: `last8Bytes(hash(requestId + salt + address))`"
    /* eslint-disable no-magic-numbers */
    return (0, utils_1.keccak256Hash)((requestId + salt + address).toLowerCase()).slice(-16);
}
exports.default = { calculate };
